import React from 'react';
import FacilityUnitsEditor from '../../../../containers/FacilityUnitsEditor';

const propTypes = {};

const defaultProps = {};

const Editor = props => (
  <FacilityUnitsEditor
    {...props}
    tableTheme="three"
  />
);

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default Editor;
